<template>
  <div class="error">
    <div class="error__tip">
      <img src="@/assets/img/error.jpg">
      <p>网络出现小异常呢～</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.error {
  width: 100%;
  height: 100vh;
  background-color: #f6f6f6;
  color: #828281;
  .error__tip {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    img {
      width: 60px;
      margin-bottom: 10px;
    }
  }
}
</style>